import { useState, useEffect } from 'react';
import axios from 'axios';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Spinner, Users, BookOpen, ChartLineUp, CheckCircle } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function CompanyDashboard() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/my-company/reports`)
      .then(res => setReport(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex justify-center py-20">
          <Spinner size={48} className="animate-spin text-[#2C3E50]" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div data-testid="company-dashboard">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1A252F] mb-2">Minha Empresa</h1>
        <p className="text-[#5C6B7A] mb-8">Visao geral dos treinamentos da sua equipe</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-5">
            <div className="flex justify-between items-start mb-3">
              <p className="text-sm text-[#5C6B7A]">Usuarios</p>
              <Users size={20} className="text-[#2C3E50]" />
            </div>
            <p className="text-3xl font-bold text-[#1A252F]">{report?.total_users || 0}</p>
          </div>
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-5">
            <div className="flex justify-between items-start mb-3">
              <p className="text-sm text-[#5C6B7A]">Matriculas</p>
              <BookOpen size={20} className="text-[#2980B9]" />
            </div>
            <p className="text-3xl font-bold text-[#1A252F]">{report?.total_enrollments || 0}</p>
          </div>
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-5">
            <div className="flex justify-between items-start mb-3">
              <p className="text-sm text-[#5C6B7A]">Concluidos</p>
              <CheckCircle size={20} className="text-[#27AE60]" />
            </div>
            <p className="text-3xl font-bold text-[#27AE60]">{report?.completed_courses || 0}</p>
          </div>
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-5">
            <div className="flex justify-between items-start mb-3">
              <p className="text-sm text-[#5C6B7A]">Taxa de Conclusao</p>
              <ChartLineUp size={20} className="text-[#F39C12]" />
            </div>
            <p className="text-3xl font-bold text-[#F39C12]">{report?.completion_rate || 0}%</p>
          </div>
        </div>

        {report?.by_course?.length > 0 && (
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-6">
            <h2 className="text-lg font-bold text-[#1A252F] mb-4">Progresso por Curso</h2>
            <div className="space-y-4">
              {report.by_course.map((item, idx) => (
                <div key={idx} className="flex items-center gap-4">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-[#1A252F] truncate">{item.course_title}</p>
                    <div className="flex items-center gap-2 mt-1">
                      <div className="flex-1 h-2 bg-[#E8ECF0] rounded-full overflow-hidden">
                        <div
                          className="h-full bg-[#27AE60] rounded-full"
                          style={{ width: `${item.enrollments > 0 ? (item.completed / item.enrollments * 100) : 0}%` }}
                        />
                      </div>
                      <span className="text-xs text-[#5C6B7A] whitespace-nowrap">
                        {item.completed}/{item.enrollments}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default CompanyDashboard;
